module.exports = {
	"2": {
		"0": {
			"headers": {
				"Result": [
					698,
					403
				],
				"Double": [
					656
				],
				"Handicap": [
					73
				],
				"Total": [
					318
				]
			},
			"priority": 0,
			"parent": null
		},
		"1": {
			"headers": {
				"Result": [
					673,
					366
				],
				"Double": [
					657
				],
				"Handicap": [
					21
				],
				"Total": [
					195
				]
			},
			"priority": 0,
			"parent": null
		},
		"2": {
			"headers": {
				"Result": [
					674,
					367
				],
				"Double": [
					658
				],
				"Handicap": [
					22
				],
				"Total": [
					196
				]
			},
			"priority": 0,
			"parent": null
		},
		"3": {
			"headers": {
				"Result": [
					675,
					368
				],
				"Double": [],
				"Handicap": [
					23
				],
				"Total": [
					197
				]
			},
			"priority": 0,
			"parent": null
		},
		"4": {
			"headers": {
				"Result": [
					676,
					369
				],
				"Double": [],
				"Handicap": [
					24
				],
				"Total": [
					198
				]
			},
			"priority": 0,
			"parent": null
		},
		"5": {
			"headers": {
				"Result": [
					677,
					370
				],
				"Double": [],
				"Handicap": [
					25
				],
				"Total": [
					199
				]
			},
			"priority": 0,
			"parent": null
		},
		"6": {
			"headers": {
				"Result": [
					678,
					371
				],
				"Double": [],
				"Handicap": [
					26
				],
				"Total": [
					200
				]
			},
			"priority": 0,
			"parent": null
		},
		"7": {
			"headers": {
				"Result": [
					679,
					372
				],
				"Double": [],
				"Handicap": [
					27
				],
				"Total": [
					201
				]
			},
			"priority": 0,
			"parent": null
		}
	},
	"3": {
		"0": {
			"headers": {
				"Result": [
					698,
					403
				],
				"Double": [
					656
				],
				"Handicap": [
					73
				],
				"Total": [
					318
				]
			},
			"priority": 0,
			"parent": null
		},
		"1": {
			"headers": {
				"Result": [
					673,
					366
				],
				"Double": [
					657
				],
				"Handicap": [
					21
				],
				"Total": [
					195
				]
			},
			"priority": 0,
			"parent": null
		},
		"2": {
			"headers": {
				"Result": [
					674,
					367
				],
				"Double": [
					658
				],
				"Handicap": [
					22
				],
				"Total": [
					196
				]
			},
			"priority": 0,
			"parent": null
		},
		"3": {
			"headers": {
				"Result": [
					675,
					368
				],
				"Double": [],
				"Handicap": [
					23
				],
				"Total": [
					197
				]
			},
			"priority": 0,
			"parent": null
		},
		"4": {
			"headers": {
				"Result": [
					362
				],
				"Double": [],
				"Handicap": [
					17
				],
				"Total": [
					176
				]
			},
			"priority": 0,
			"parent": null
		},
		"5": {
			"headers": {
				"Result": [
					358
				],
				"Double": [],
				"Handicap": [
					13
				],
				"Total": [
					172
				]
			},
			"priority": 0,
			"parent": null
		},
		"6": {
			"headers": {
				"Result": [
					363
				],
				"Double": [],
				"Handicap": [
					18
				],
				"Total": [
					177
				]
			},
			"priority": 0,
			"parent": null
		},
		"7": {
			"headers": {
				"Result": [
					359
				],
				"Double": [],
				"Handicap": [
					14
				],
				"Total": [
					173
				]
			},
			"priority": 0,
			"parent": null
		}
	},
	"4": {
		"0": {
			"headers": {
				"Result": [
					698,
					403
				],
				"Double": [
					656
				],
				"Handicap": [
					73
				],
				"Total": [
					318
				]
			},
			"priority": 0,
			"parent": null
		},
		"1": {
			"headers": {
				"Result": [
					673,
					366
				],
				"Double": [
					657
				],
				"Handicap": [
					21
				],
				"Total": [
					195
				]
			},
			"priority": 0,
			"parent": null
		},
		"2": {
			"headers": {
				"Result": [
					674,
					367
				],
				"Double": [
					658
				],
				"Handicap": [
					22
				],
				"Total": [
					196
				]
			},
			"priority": 0,
			"parent": null
		},
		"3": {
			"headers": {
				"Result": [
					675,
					368
				],
				"Double": [],
				"Handicap": [
					23
				],
				"Total": [
					197
				]
			},
			"priority": 0,
			"parent": null
		},
		"4": {
			"headers": {
				"Result": [
					676,
					369
				],
				"Double": [],
				"Handicap": [
					24
				],
				"Total": [
					198
				]
			},
			"priority": 0,
			"parent": null
		},
		"5": {
			"headers": {
				"Result": [
					677,
					370
				],
				"Double": [],
				"Handicap": [
					25
				],
				"Total": [
					199
				]
			},
			"priority": 0,
			"parent": null
		},
		"6": {
			"headers": {
				"Result": [
					678,
					371
				],
				"Double": [],
				"Handicap": [
					26
				],
				"Total": [
					200
				]
			},
			"priority": 0,
			"parent": null
		},
		"7": {
			"headers": {
				"Result": [
					362
				],
				"Double": [],
				"Handicap": [
					17
				],
				"Total": [
					176
				]
			},
			"priority": 0,
			"parent": null
		},
		"8": {
			"headers": {
				"Result": [
					358
				],
				"Double": [],
				"Handicap": [
					13
				],
				"Total": [
					172
				]
			},
			"priority": 0,
			"parent": null
		},
		"9": {
			"headers": {
				"Result": [
					363
				],
				"Double": [],
				"Handicap": [
					18
				],
				"Total": [
					177
				]
			},
			"priority": 0,
			"parent": null
		},
		"10": {
			"headers": {
				"Result": [
					359
				],
				"Double": [],
				"Handicap": [
					14
				],
				"Total": [
					173
				]
			},
			"priority": 0,
			"parent": null
		},
		"11": {
			"headers": {
				"Result": [
					364
				],
				"Double": [],
				"Handicap": [
					19
				],
				"Total": [
					178
				]
			},
			"priority": 0,
			"parent": null
		},
		"12": {
			"headers": {
				"Result": [
					360
				],
				"Double": [],
				"Handicap": [
					15
				],
				"Total": [
					174
				]
			},
			"priority": 0,
			"parent": null
		},
		"13": {
			"headers": {
				"Result": [
					365
				],
				"Double": [],
				"Handicap": [
					20
				],
				"Total": [
					179
				]
			},
			"priority": 0,
			"parent": null
		},
		"14": {
			"headers": {
				"Result": [
					361
				],
				"Double": [],
				"Handicap": [
					16
				],
				"Total": [
					175
				]
			},
			"priority": 0,
			"parent": null
		}
	},
	"5": {
		"0": {
			"headers": {
				"Result": [
					698,
					403
				],
				"Double": [
					656
				],
				"Handicap": [
					74
				],
				"Total": [
					349
				]
			},
			"priority": 0,
			"parent": null
		}
	},
	"6": {
		"0": {
			"headers": {
				"Result": [
					698,
					403
				],
				"Double": [
					656
				],
				"Handicap": [
					73
				],
				"Total": [
					318
				]
			},
			"priority": 0,
			"parent": null
		},
		"1": {
			"headers": {
				"Result": [
					673,
					366
				],
				"Double": [
					657
				],
				"Handicap": [
					21
				],
				"Total": [
					195
				]
			},
			"priority": 0,
			"parent": null
		},
		"2": {
			"headers": {
				"Result": [
					674,
					367
				],
				"Double": [
					658
				],
				"Handicap": [
					22
				],
				"Total": [
					196
				]
			},
			"priority": 0,
			"parent": null
		},
		"3": {
			"headers": {
				"Result": [
					675,
					368
				],
				"Double": [],
				"Handicap": [
					23
				],
				"Total": [
					197
				]
			},
			"priority": 0,
			"parent": null
		},
		"4": {
			"headers": {
				"Result": [
					676,
					369
				],
				"Double": [],
				"Handicap": [
					24
				],
				"Total": [
					198
				]
			},
			"priority": 0,
			"parent": null
		},
		"5": {
			"headers": {
				"Result": [
					677,
					370
				],
				"Double": [],
				"Handicap": [
					25
				],
				"Total": [
					199
				]
			},
			"priority": 0,
			"parent": null
		}
	},
	"7": {
		"0": {
			"headers": {
				"Result": [
					698,
					403
				],
				"Double": [
					656
				],
				"Handicap": [
					74
				],
				"Total": [
					349
				]
			},
			"priority": 1,
			"parent": null
		},
		"1": {
			"headers": {
				"Result": [
					673,
					366
				],
				"Double": [
					657
				],
				"Handicap": [
					21
				],
				"Total": [
					195
				]
			},
			"priority": 2,
			"parent": null
		},
		"2": {
			"headers": {
				"Result": [
					674,
					367
				],
				"Double": [
					658
				],
				"Handicap": [
					22
				],
				"Total": [
					196
				]
			},
			"priority": 3,
			"parent": null
		},
		"3": {
			"headers": {
				"Result": [
					661
				],
				"Double": [
					650
				],
				"Handicap": [
					2
				],
				"Total": [
					160
				]
			},
			"priority": 8,
			"parent": null
		},
		"4": {
			"headers": {
				"Result": [
					664
				],
				"Double": [
					651
				],
				"Handicap": [
					5
				],
				"Total": [
					163
				]
			},
			"priority": 9,
			"parent": null
		},
		"5": {
			"headers": {
				"Result": [
					666
				],
				"Double": [
					652
				],
				"Handicap": [
					7
				],
				"Total": [
					165
				]
			},
			"priority": 10,
			"parent": null
		},
		"6": {
			"headers": {
				"Result": [
					667
				],
				"Double": [
					653
				],
				"Handicap": [
					939
				],
				"Total": [
					166
				]
			},
			"priority": 13,
			"parent": null
		},
		"7": {
			"headers": {
				"Result": [
					669
				],
				"Double": [
					654
				],
				"Handicap": [
					9
				],
				"Total": [
					168
				]
			},
			"priority": 14,
			"parent": null
		},
		"8": {
			"headers": {
				"Result": [
					672
				],
				"Double": [
					655
				],
				"Handicap": [
					12
				],
				"Total": [
					171
				]
			},
			"priority": 15,
			"parent": null
		},
		"9": {
			"headers": {
				"Result": [
					689
				],
				"Double": [],
				"Handicap": [
					66
				],
				"Total": [
					255
				]
			},
			"priority": 4,
			"parent": null
		},
		"10": {
			"headers": {
				"Result": [
					690
				],
				"Double": [],
				"Handicap": [
					67
				],
				"Total": [
					258
				]
			},
			"priority": 11,
			"parent": 9
		},
		"11": {
			"headers": {
				"Result": [
					699
				],
				"Double": [],
				"Handicap": [
					81
				],
				"Total": [
					353
				]
			},
			"priority": 5,
			"parent": null
		},
		"12": {
			"headers": {
				"Result": [
					691
				],
				"Double": [],
				"Handicap": [
					68
				],
				"Total": [
					259
				]
			},
			"priority": 12,
			"parent": 11
		},
		"13": {
			"headers": {
				"Result": [
					692
				],
				"Double": [
					659
				],
				"Handicap": [
					69
				],
				"Total": [
					262
				]
			},
			"priority": 6,
			"parent": null
		},
		"14": {
			"headers": {
				"Result": [
					693
				],
				"Double": [],
				"Handicap": [
					70
				],
				"Total": [
					263
				]
			},
			"priority": 16,
			"parent": 13
		},
		"15": {
			"headers": {
				"Result": [
					695
				],
				"Double": [],
				"Handicap": [
					72
				],
				"Total": [
					277
				]
			},
			"priority": 17,
			"parent": 13
		},
		"16": {
			"headers": {
				"Result": [],
				"Double": [],
				"Handicap": [],
				"Total": []
			},
			"priority": 7,
			"parent": null
		}
	},
	"8": {
		"0": {
			"headers": {
				"Result": [
					698,
					403
				],
				"Double": [
					656
				],
				"Handicap": [
					74
				],
				"Total": [
					349
				]
			},
			"priority": 0,
			"parent": null
		},
		"1": {
			"headers": {
				"Result": [
					673,
					366
				],
				"Double": [
					657
				],
				"Handicap": [
					21
				],
				"Total": [
					195
				]
			},
			"priority": 0,
			"parent": null
		},
		"2": {
			"headers": {
				"Result": [
					674,
					367
				],
				"Double": [
					658
				],
				"Handicap": [
					22
				],
				"Total": [
					196
				]
			},
			"priority": 0,
			"parent": null
		},
		"3": {
			"headers": {
				"Result": [
					675,
					368
				],
				"Double": [],
				"Handicap": [
					23
				],
				"Total": [
					197
				]
			},
			"priority": 0,
			"parent": null
		},
		"4": {
			"headers": {
				"Result": [
					676,
					369
				],
				"Double": [],
				"Handicap": [
					24
				],
				"Total": [
					198
				]
			},
			"priority": 0,
			"parent": null
		}
	},
	"9": {
		"0": {
			"headers": {
				"Result": [
					698,
					403
				],
				"Double": [
					656
				],
				"Handicap": [
					74
				],
				"Total": [
					349
				]
			},
			"priority": 0,
			"parent": null
		},
		"1": {
			"headers": {
				"Result": [
					673,
					366
				],
				"Double": [
					657
				],
				"Handicap": [
					21
				],
				"Total": [
					195
				]
			},
			"priority": 0,
			"parent": null
		},
		"2": {
			"headers": {
				"Result": [
					674,
					367
				],
				"Double": [
					658
				],
				"Handicap": [
					22
				],
				"Total": [
					196
				]
			},
			"priority": 0,
			"parent": null
		}
	},
	"10": {
		"0": {
			"headers": {
				"Result": [
					698,
					403
				],
				"Double": [
					656
				],
				"Handicap": [
					74
				],
				"Total": [
					349
				]
			},
			"priority": 0,
			"parent": null
		}
	},
	"11": {
		"0": {
			"headers": {
				"Result": [
					698,
					403
				],
				"Double": [
					656
				],
				"Handicap": [
					74
				],
				"Total": [
					349
				]
			},
			"priority": 0,
			"parent": null
		}
	},
	"12": {
		"0": {
			"headers": {
				"Result": [
					698,
					403
				],
				"Double": [
					656
				],
				"Handicap": [
					74
				],
				"Total": [
					349
				]
			},
			"priority": 0,
			"parent": null
		}
	},
	"13": {
		"0": {
			"headers": {
				"Result": [
					698,
					403
				],
				"Double": [
					656
				],
				"Handicap": [
					74
				],
				"Total": [
					349
				]
			},
			"priority": 0,
			"parent": null
		}
	},
	"14": {
		"0": {
			"headers": {
				"Result": [
					698,
					403
				],
				"Double": [
					656
				],
				"Handicap": [
					74
				],
				"Total": [
					349
				]
			},
			"priority": 0,
			"parent": null
		}
	},
	"15": {
		"0": {
			"headers": {
				"Result": [
					698,
					403
				],
				"Double": [
					656
				],
				"Handicap": [
					74
				],
				"Total": [
					349
				]
			},
			"priority": 0,
			"parent": null
		}
	},
	"16": {
		"0": {
			"headers": {
				"Result": [
					698,
					403
				],
				"Double": [
					656
				],
				"Handicap": [
					74
				],
				"Total": [
					349
				]
			},
			"priority": 0,
			"parent": null
		}
	},
	"17": {
		"0": {
			"headers": {
				"Result": [
					698,
					403
				],
				"Double": [
					656
				],
				"Handicap": [
					74
				],
				"Total": [
					349
				]
			},
			"priority": 0,
			"parent": null
		}
	},
	"18": {
		"0": {
			"headers": {
				"Result": [
					698,
					403
				],
				"Double": [
					656
				],
				"Handicap": [
					74
				],
				"Total": [
					349
				]
			},
			"priority": 0,
			"parent": null
		},
		"1": {
			"headers": {
				"Result": [
					673,
					366
				],
				"Double": [
					657
				],
				"Handicap": [
					21
				],
				"Total": [
					195
				]
			},
			"priority": 0,
			"parent": null
		},
		"2": {
			"headers": {
				"Result": [
					674,
					367
				],
				"Double": [
					658
				],
				"Handicap": [
					22
				],
				"Total": [
					196
				]
			},
			"priority": 0,
			"parent": null
		},
		"3": {
			"headers": {
				"Result": [
					675,
					368
				],
				"Double": [],
				"Handicap": [
					23
				],
				"Total": [
					197
				]
			},
			"priority": 0,
			"parent": null
		}
	},
	"19": {
		"0": {
			"headers": {
				"Result": [
					698,
					403
				],
				"Double": [
					656
				],
				"Handicap": [
					74
				],
				"Total": [
					349
				]
			},
			"priority": 0,
			"parent": null
		},
		"1": {
			"headers": {
				"Result": [
					673,
					366
				],
				"Double": [
					657
				],
				"Handicap": [
					21
				],
				"Total": [
					195
				]
			},
			"priority": 0,
			"parent": null
		},
		"2": {
			"headers": {
				"Result": [
					674,
					367
				],
				"Double": [
					658
				],
				"Handicap": [
					22
				],
				"Total": [
					196
				]
			},
			"priority": 0,
			"parent": null
		}
	},
	"20": {
		"0": {
			"headers": {
				"Result": [
					698,
					403
				],
				"Double": [
					656
				],
				"Handicap": [
					74
				],
				"Total": [
					349
				]
			},
			"priority": 0,
			"parent": null
		},
		"1": {
			"headers": {
				"Result": [
					673,
					366
				],
				"Double": [
					657
				],
				"Handicap": [
					21
				],
				"Total": [
					195
				]
			},
			"priority": 0,
			"parent": null
		},
		"2": {
			"headers": {
				"Result": [
					674,
					367
				],
				"Double": [
					658
				],
				"Handicap": [
					22
				],
				"Total": [
					196
				]
			},
			"priority": 0,
			"parent": null
		},
		"3": {
			"headers": {
				"Result": [
					675,
					368
				],
				"Double": [],
				"Handicap": [
					23
				],
				"Total": [
					197
				]
			},
			"priority": 0,
			"parent": null
		},
		"4": {
			"headers": {
				"Result": [
					676,
					369
				],
				"Double": [],
				"Handicap": [
					24
				],
				"Total": [
					198
				]
			},
			"priority": 0,
			"parent": null
		},
		"5": {
			"headers": {
				"Result": [
					677,
					370
				],
				"Double": [],
				"Handicap": [
					25
				],
				"Total": [
					199
				]
			},
			"priority": 0,
			"parent": null
		},
		"6": {
			"headers": {
				"Result": [
					678,
					371
				],
				"Double": [],
				"Handicap": [
					26
				],
				"Total": [
					200
				]
			},
			"priority": 0,
			"parent": null
		},
		"7": {
			"headers": {
				"Result": [
					679,
					372
				],
				"Double": [],
				"Handicap": [
					27
				],
				"Total": [
					201
				]
			},
			"priority": 0,
			"parent": null
		},
		"8": {
			"headers": {
				"Result": [
					680,
					373
				],
				"Double": [],
				"Handicap": [
					28
				],
				"Total": [
					202
				]
			},
			"priority": 0,
			"parent": null
		}
	},
	"21": {
		"0": {
			"headers": {
				"Result": [
					698,
					403
				],
				"Double": [
					656
				],
				"Handicap": [
					74
				],
				"Total": [
					349
				]
			},
			"priority": 0,
			"parent": null
		}
	},
	"23": {
		"0": {
			"headers": {
				"Result": [
					698,
					403
				],
				"Double": [
					656
				],
				"Handicap": [
					74
				],
				"Total": [
					349
				]
			},
			"priority": 0,
			"parent": null
		}
	},
	"24": {
		"0": {
			"headers": {
				"Result": [
					698,
					403
				],
				"Double": [
					656
				],
				"Handicap": [
					74
				],
				"Total": [
					349
				]
			},
			"priority": 0,
			"parent": null
		}
	},
	"25": {
		"0": {
			"headers": {
				"Result": [
					698,
					403
				],
				"Double": [
					656
				],
				"Handicap": [
					74
				],
				"Total": [
					349
				]
			},
			"priority": 0,
			"parent": null
		}
	},
	"26": {
		"0": {
			"headers": {
				"Result": [
					698,
					403
				],
				"Double": [
					656
				],
				"Handicap": [
					74
				],
				"Total": [
					349
				]
			},
			"priority": 0,
			"parent": null
		}
	},
	"27": {
		"0": {
			"headers": {
				"Result": [
					698,
					403
				],
				"Double": [
					656
				],
				"Handicap": [
					74
				],
				"Total": [
					349
				]
			},
			"priority": 0,
			"parent": null
		}
	},
	"28": {
		"0": {
			"headers": {
				"Result": [
					698,
					403
				],
				"Double": [
					656
				],
				"Handicap": [
					74
				],
				"Total": [
					349
				]
			},
			"priority": 0,
			"parent": null
		}
	},
	"29": {
		"0": {
			"headers": {
				"Result": [
					698,
					403
				],
				"Double": [
					656
				],
				"Handicap": [
					74
				],
				"Total": [
					349
				]
			},
			"priority": 0,
			"parent": null
		},
		"1": {
			"headers": {
				"Result": [
					673,
					366
				],
				"Double": [
					657
				],
				"Handicap": [
					21
				],
				"Total": [
					195
				]
			},
			"priority": 0,
			"parent": null
		},
		"2": {
			"headers": {
				"Result": [
					674,
					367
				],
				"Double": [
					658
				],
				"Handicap": [
					22
				],
				"Total": [
					196
				]
			},
			"priority": 0,
			"parent": null
		},
		"3": {
			"headers": {
				"Result": [
					675,
					368
				],
				"Double": [],
				"Handicap": [
					23
				],
				"Total": [
					197
				]
			},
			"priority": 0,
			"parent": null
		},
		"4": {
			"headers": {
				"Result": [
					676,
					369
				],
				"Double": [],
				"Handicap": [
					24
				],
				"Total": [
					198
				]
			},
			"priority": 0,
			"parent": null
		},
		"5": {
			"headers": {
				"Result": [
					677,
					370
				],
				"Double": [],
				"Handicap": [
					25
				],
				"Total": [
					199
				]
			},
			"priority": 0,
			"parent": null
		},
		"6": {
			"headers": {
				"Result": [
					678,
					371
				],
				"Double": [],
				"Handicap": [
					26
				],
				"Total": [
					200
				]
			},
			"priority": 0,
			"parent": null
		},
		"7": {
			"headers": {
				"Result": [
					679,
					372
				],
				"Double": [],
				"Handicap": [
					27
				],
				"Total": [
					201
				]
			},
			"priority": 0,
			"parent": null
		},
		"8": {
			"headers": {
				"Result": [
					680,
					373
				],
				"Double": [],
				"Handicap": [
					28
				],
				"Total": [
					202
				]
			},
			"priority": 0,
			"parent": null
		},
		"9": {
			"headers": {
				"Result": [
					374
				],
				"Double": [],
				"Handicap": [
					29
				],
				"Total": [
					203
				]
			},
			"priority": 0,
			"parent": null
		},
		"10": {
			"headers": {
				"Result": [
					375
				],
				"Double": [],
				"Handicap": [
					30
				],
				"Total": [
					204
				]
			},
			"priority": 0,
			"parent": null
		},
		"11": {
			"headers": {
				"Result": [
					376
				],
				"Double": [],
				"Handicap": [
					31
				],
				"Total": [
					205
				]
			},
			"priority": 0,
			"parent": null
		},
		"12": {
			"headers": {
				"Result": [
					377
				],
				"Double": [],
				"Handicap": [
					32
				],
				"Total": [
					206
				]
			},
			"priority": 0,
			"parent": null
		},
		"13": {
			"headers": {
				"Result": [
					378
				],
				"Double": [],
				"Handicap": [
					33
				],
				"Total": [
					207
				]
			},
			"priority": 0,
			"parent": null
		},
		"14": {
			"headers": {
				"Result": [
					379
				],
				"Double": [],
				"Handicap": [
					34
				],
				"Total": [
					208
				]
			},
			"priority": 0,
			"parent": null
		},
		"15": {
			"headers": {
				"Result": [
					380
				],
				"Double": [],
				"Handicap": [
					35
				],
				"Total": [
					209
				]
			},
			"priority": 0,
			"parent": null
		},
		"16": {
			"headers": {
				"Result": [
					381
				],
				"Double": [],
				"Handicap": [
					36
				],
				"Total": [
					210
				]
			},
			"priority": 0,
			"parent": null
		},
		"17": {
			"headers": {
				"Result": [
					382
				],
				"Double": [],
				"Handicap": [
					37
				],
				"Total": [
					211
				]
			},
			"priority": 0,
			"parent": null
		},
		"18": {
			"headers": {
				"Result": [
					383
				],
				"Double": [],
				"Handicap": [
					38
				],
				"Total": [
					212
				]
			},
			"priority": 0,
			"parent": null
		},
		"19": {
			"headers": {
				"Result": [
					384
				],
				"Double": [],
				"Handicap": [
					39
				],
				"Total": [
					213
				]
			},
			"priority": 0,
			"parent": null
		},
		"20": {
			"headers": {
				"Result": [
					385
				],
				"Double": [],
				"Handicap": [
					40
				],
				"Total": [
					214
				]
			},
			"priority": 0,
			"parent": null
		},
		"21": {
			"headers": {
				"Result": [
					386
				],
				"Double": [],
				"Handicap": [
					41
				],
				"Total": [
					215
				]
			},
			"priority": 0,
			"parent": null
		},
		"22": {
			"headers": {
				"Result": [
					387
				],
				"Double": [],
				"Handicap": [
					42
				],
				"Total": [
					216
				]
			},
			"priority": 0,
			"parent": null
		},
		"23": {
			"headers": {
				"Result": [
					388
				],
				"Double": [],
				"Handicap": [
					43
				],
				"Total": [
					217
				]
			},
			"priority": 0,
			"parent": null
		},
		"24": {
			"headers": {
				"Result": [
					389
				],
				"Double": [],
				"Handicap": [
					44
				],
				"Total": [
					218
				]
			},
			"priority": 0,
			"parent": null
		},
		"25": {
			"headers": {
				"Result": [
					390
				],
				"Double": [],
				"Handicap": [
					45
				],
				"Total": [
					219
				]
			},
			"priority": 0,
			"parent": null
		},
		"26": {
			"headers": {
				"Result": [
					391
				],
				"Double": [],
				"Handicap": [
					46
				],
				"Total": [
					220
				]
			},
			"priority": 0,
			"parent": null
		},
		"27": {
			"headers": {
				"Result": [
					392
				],
				"Double": [],
				"Handicap": [
					47
				],
				"Total": [
					221
				]
			},
			"priority": 0,
			"parent": null
		},
		"28": {
			"headers": {
				"Result": [
					393
				],
				"Double": [],
				"Handicap": [
					48
				],
				"Total": [
					222
				]
			},
			"priority": 0,
			"parent": null
		},
		"29": {
			"headers": {
				"Result": [
					394
				],
				"Double": [],
				"Handicap": [
					49
				],
				"Total": [
					223
				]
			},
			"priority": 0,
			"parent": null
		},
		"30": {
			"headers": {
				"Result": [
					395
				],
				"Double": [],
				"Handicap": [
					50
				],
				"Total": [
					224
				]
			},
			"priority": 0,
			"parent": null
		},
		"31": {
			"headers": {
				"Result": [
					396
				],
				"Double": [],
				"Handicap": [
					51
				],
				"Total": [
					225
				]
			},
			"priority": 0,
			"parent": null
		},
		"32": {
			"headers": {
				"Result": [
					397
				],
				"Double": [],
				"Handicap": [
					52
				],
				"Total": [
					226
				]
			},
			"priority": 0,
			"parent": null
		},
		"33": {
			"headers": {
				"Result": [
					398
				],
				"Double": [],
				"Handicap": [
					53
				],
				"Total": [
					227
				]
			},
			"priority": 0,
			"parent": null
		},
		"34": {
			"headers": {
				"Result": [
					399
				],
				"Double": [],
				"Handicap": [
					54
				],
				"Total": [
					228
				]
			},
			"priority": 0,
			"parent": null
		},
		"35": {
			"headers": {
				"Result": [
					400
				],
				"Double": [],
				"Handicap": [
					55
				],
				"Total": [
					229
				]
			},
			"priority": 0,
			"parent": null
		},
		"36": {
			"headers": {
				"Result": [
					401
				],
				"Double": [],
				"Handicap": [
					56
				],
				"Total": [
					230
				]
			},
			"priority": 0,
			"parent": null
		},
		"37": {
			"headers": {
				"Result": [
					402
				],
				"Double": [],
				"Handicap": [
					57
				],
				"Total": [
					231
				]
			},
			"priority": 0,
			"parent": null
		}
	},
	"30": {
		"0": {
			"headers": {
				"Result": [
					698,
					403
				],
				"Double": [
					656
				],
				"Handicap": [
					74
				],
				"Total": [
					349
				]
			},
			"priority": 0,
			"parent": null
		},
		"1": {
			"headers": {
				"Result": [
					673,
					366
				],
				"Double": [
					657
				],
				"Handicap": [
					21
				],
				"Total": [
					195
				]
			},
			"priority": 0,
			"parent": null
		},
		"2": {
			"headers": {
				"Result": [
					674,
					367
				],
				"Double": [
					658
				],
				"Handicap": [
					22
				],
				"Total": [
					196
				]
			},
			"priority": 0,
			"parent": null
		},
		"3": {
			"headers": {
				"Result": [
					675,
					368
				],
				"Double": [],
				"Handicap": [
					23
				],
				"Total": [
					197
				]
			},
			"priority": 0,
			"parent": null
		},
		"4": {
			"headers": {
				"Result": [
					662
				],
				"Double": [],
				"Handicap": [
					3
				],
				"Total": [
					161
				]
			},
			"priority": 0,
			"parent": null
		},
		"5": {
			"headers": {
				"Result": [
					663
				],
				"Double": [],
				"Handicap": [
					4
				],
				"Total": [
					162
				]
			},
			"priority": 0,
			"parent": null
		},
		"6": {
			"headers": {
				"Result": [
					665
				],
				"Double": [],
				"Handicap": [
					6
				],
				"Total": [
					164
				]
			},
			"priority": 0,
			"parent": null
		},
		"7": {
			"headers": {
				"Result": [
					668
				],
				"Double": [],
				"Handicap": [
					8
				],
				"Total": [
					167
				]
			},
			"priority": 0,
			"parent": null
		},
		"8": {
			"headers": {
				"Result": [
					670
				],
				"Double": [],
				"Handicap": [
					10
				],
				"Total": [
					169
				]
			},
			"priority": 0,
			"parent": null
		},
		"9": {
			"headers": {
				"Result": [
					671
				],
				"Double": [],
				"Handicap": [
					11
				],
				"Total": [
					170
				]
			},
			"priority": 0,
			"parent": null
		}
	},
	"31": {
		"0": {
			"headers": {
				"Result": [
					698,
					403
				],
				"Double": [
					656
				],
				"Handicap": [
					74
				],
				"Total": [
					349
				]
			},
			"priority": 0,
			"parent": null
		},
		"1": {
			"headers": {
				"Result": [
					673,
					366
				],
				"Double": [
					657
				],
				"Handicap": [
					21
				],
				"Total": [
					195
				]
			},
			"priority": 0,
			"parent": null
		},
		"2": {
			"headers": {
				"Result": [
					674,
					367
				],
				"Double": [
					658
				],
				"Handicap": [
					22
				],
				"Total": [
					196
				]
			},
			"priority": 0,
			"parent": null
		},
		"3": {
			"headers": {
				"Result": [
					675,
					368
				],
				"Double": [],
				"Handicap": [
					23
				],
				"Total": [
					197
				]
			},
			"priority": 0,
			"parent": null
		},
		"4": {
			"headers": {
				"Result": [
					676,
					369
				],
				"Double": [],
				"Handicap": [
					24
				],
				"Total": [
					198
				]
			},
			"priority": 0,
			"parent": null
		},
		"5": {
			"headers": {
				"Result": [
					685
				],
				"Double": [],
				"Handicap": [
					62
				],
				"Total": [
					248
				]
			},
			"priority": 0,
			"parent": null
		},
		"6": {
			"headers": {
				"Result": [
					684
				],
				"Double": [],
				"Handicap": [
					61
				],
				"Total": [
					246
				]
			},
			"priority": 0,
			"parent": null
		},
		"7": {
			"headers": {
				"Result": [
					681
				],
				"Double": [],
				"Handicap": [
					58
				],
				"Total": [
					238
				]
			},
			"priority": 0,
			"parent": null
		},
		"8": {
			"headers": {
				"Result": [
					682
				],
				"Double": [],
				"Handicap": [
					59
				],
				"Total": [
					239
				]
			},
			"priority": 0,
			"parent": null
		}
	},
	"32": {
		"0": {
			"headers": {
				"Result": [
					698,
					403
				],
				"Double": [
					656
				],
				"Handicap": [
					73
				],
				"Total": [
					318
				]
			},
			"priority": 0,
			"parent": null
		},
		"1": {
			"headers": {
				"Result": [
					673,
					366
				],
				"Double": [
					657
				],
				"Handicap": [
					21
				],
				"Total": [
					195
				]
			},
			"priority": 0,
			"parent": null
		},
		"2": {
			"headers": {
				"Result": [
					674,
					367
				],
				"Double": [
					658
				],
				"Handicap": [
					22
				],
				"Total": [
					196
				]
			},
			"priority": 0,
			"parent": null
		},
		"3": {
			"headers": {
				"Result": [
					675,
					368
				],
				"Double": [],
				"Handicap": [
					23
				],
				"Total": [
					197
				]
			},
			"priority": 0,
			"parent": null
		},
		"4": {
			"headers": {
				"Result": [
					362
				],
				"Double": [],
				"Handicap": [
					17
				],
				"Total": [
					176
				]
			},
			"priority": 0,
			"parent": null
		},
		"5": {
			"headers": {
				"Result": [
					358
				],
				"Double": [],
				"Handicap": [
					13
				],
				"Total": [
					172
				]
			},
			"priority": 0,
			"parent": null
		},
		"6": {
			"headers": {
				"Result": [
					363
				],
				"Double": [],
				"Handicap": [
					18
				],
				"Total": [
					177
				]
			},
			"priority": 0,
			"parent": null
		},
		"7": {
			"headers": {
				"Result": [
					359
				],
				"Double": [],
				"Handicap": [
					14
				],
				"Total": [
					173
				]
			},
			"priority": 0,
			"parent": null
		},
		"8": {
			"headers": {
				"Result": [
					364
				],
				"Double": [],
				"Handicap": [
					19
				],
				"Total": [
					178
				]
			},
			"priority": 0,
			"parent": null
		},
		"9": {
			"headers": {
				"Result": [
					360
				],
				"Double": [],
				"Handicap": [
					15
				],
				"Total": [
					174
				]
			},
			"priority": 0,
			"parent": null
		}
	},
	"33": {
		"0": {
			"headers": {
				"Result": [
					698,
					403
				],
				"Double": [
					656
				],
				"Handicap": [
					74
				],
				"Total": [
					349
				]
			},
			"priority": 0,
			"parent": null
		}
	},
	"34": {
		"0": {
			"headers": {
				"Result": [
					698,
					403
				],
				"Double": [
					656
				],
				"Handicap": [
					74
				],
				"Total": [
					349
				]
			},
			"priority": 0,
			"parent": null
		},
		"1": {
			"headers": {
				"Result": [
					673,
					366
				],
				"Double": [
					657
				],
				"Handicap": [
					21
				],
				"Total": [
					195
				]
			},
			"priority": 0,
			"parent": null
		},
		"2": {
			"headers": {
				"Result": [
					674,
					367
				],
				"Double": [
					658
				],
				"Handicap": [
					22
				],
				"Total": [
					196
				]
			},
			"priority": 0,
			"parent": null
		},
		"3": {
			"headers": {
				"Result": [
					661
				],
				"Double": [],
				"Handicap": [
					2
				],
				"Total": [
					160
				]
			},
			"priority": 0,
			"parent": null
		},
		"4": {
			"headers": {
				"Result": [
					664
				],
				"Double": [],
				"Handicap": [
					5
				],
				"Total": [
					163
				]
			},
			"priority": 0,
			"parent": null
		},
		"5": {
			"headers": {
				"Result": [
					666
				],
				"Double": [],
				"Handicap": [
					7
				],
				"Total": [
					165
				]
			},
			"priority": 0,
			"parent": null
		},
		"6": {
			"headers": {
				"Result": [
					667
				],
				"Double": [],
				"Handicap": [
					939
				],
				"Total": [
					166
				]
			},
			"priority": 0,
			"parent": null
		},
		"7": {
			"headers": {
				"Result": [
					669
				],
				"Double": [],
				"Handicap": [
					9
				],
				"Total": [
					168
				]
			},
			"priority": 0,
			"parent": null
		},
		"8": {
			"headers": {
				"Result": [
					672
				],
				"Double": [],
				"Handicap": [
					12
				],
				"Total": [
					171
				]
			},
			"priority": 0,
			"parent": null
		},
		"9": {
			"headers": {
				"Result": [],
				"Double": [],
				"Handicap": [],
				"Total": [
					255
				]
			},
			"priority": 0,
			"parent": null
		},
		"10": {
			"headers": {
				"Result": [],
				"Double": [],
				"Handicap": [],
				"Total": [
					353
				]
			},
			"priority": 0,
			"parent": null
		}
	},
	"35": {
		"0": {
			"headers": {
				"Result": [
					698,
					403
				],
				"Double": [
					656
				],
				"Handicap": [
					74
				],
				"Total": [
					349
				]
			},
			"priority": 0,
			"parent": null
		},
		"1": {
			"headers": {
				"Result": [
					673,
					366
				],
				"Double": [
					657
				],
				"Handicap": [
					21
				],
				"Total": [
					195
				]
			},
			"priority": 0,
			"parent": null
		}
	},
	"36": {
		"0": {
			"headers": {
				"Result": [
					698,
					403
				],
				"Double": [
					656
				],
				"Handicap": [
					74
				],
				"Total": [
					349
				]
			},
			"priority": 0,
			"parent": null
		},
		"1": {
			"headers": {
				"Result": [
					673,
					366
				],
				"Double": [
					657
				],
				"Handicap": [
					21
				],
				"Total": [
					195
				]
			},
			"priority": 0,
			"parent": null
		}
	},
	"37": {
		"0": {
			"headers": {
				"Result": [
					698,
					403
				],
				"Double": [
					656
				],
				"Handicap": [
					74
				],
				"Total": [
					349
				]
			},
			"priority": 0,
			"parent": null
		}
	},
	"38": {
		"0": {
			"headers": {
				"Result": [
					698,
					403
				],
				"Double": [
					656
				],
				"Handicap": [
					74
				],
				"Total": [
					349
				]
			},
			"priority": 0,
			"parent": null
		},
		"1": {
			"headers": {
				"Result": [
					366,
					673
				],
				"Double": [],
				"Handicap": [],
				"Total": []
			},
			"priority": 1,
			"parent": null
		},
		"2": {
			"headers": {
				"Result": [
					367,
					674
				],
				"Double": [],
				"Handicap": [],
				"Total": []
			},
			"priority": 2,
			"parent": null
		},
		"3": {
			"headers": {
				"Result": [
					368,
					675
				],
				"Double": [],
				"Handicap": [],
				"Total": []
			},
			"priority": 3,
			"parent": null
		},
		"4": {
			"headers": {
				"Result": [
					369,
					676
				],
				"Double": [],
				"Handicap": [],
				"Total": []
			},
			"priority": 4,
			"parent": null
		},
		"5": {
			"headers": {
				"Result": [
					370,
					677
				],
				"Double": [],
				"Handicap": [],
				"Total": []
			},
			"priority": 5,
			"parent": null
		}
	},
	"39": {
		"0": {
			"headers": {
				"Result": [
					698,
					403
				],
				"Double": [
					656
				],
				"Handicap": [
					74
				],
				"Total": [
					349
				]
			},
			"priority": 0,
			"parent": null
		},
		"1": {
			"headers": {
				"Result": [
					673,
					366
				],
				"Double": [
					657
				],
				"Handicap": [
					21
				],
				"Total": [
					195
				]
			},
			"priority": 0,
			"parent": null
		},
		"2": {
			"headers": {
				"Result": [
					674,
					367
				],
				"Double": [
					658
				],
				"Handicap": [
					22
				],
				"Total": [
					196
				]
			},
			"priority": 0,
			"parent": null
		},
		"3": {
			"headers": {
				"Result": [
					675,
					368
				],
				"Double": [],
				"Handicap": [
					23
				],
				"Total": [
					197
				]
			},
			"priority": 0,
			"parent": null
		},
		"4": {
			"headers": {
				"Result": [
					676,
					369
				],
				"Double": [],
				"Handicap": [
					24
				],
				"Total": [
					198
				]
			},
			"priority": 0,
			"parent": null
		},
		"5": {
			"headers": {
				"Result": [
					685
				],
				"Double": [],
				"Handicap": [
					62
				],
				"Total": [
					248
				]
			},
			"priority": 0,
			"parent": null
		},
		"6": {
			"headers": {
				"Result": [
					684
				],
				"Double": [],
				"Handicap": [
					61
				],
				"Total": [
					246
				]
			},
			"priority": 0,
			"parent": null
		},
		"7": {
			"headers": {
				"Result": [
					681
				],
				"Double": [],
				"Handicap": [
					58
				],
				"Total": [
					238
				]
			},
			"priority": 0,
			"parent": null
		},
		"8": {
			"headers": {
				"Result": [
					682
				],
				"Double": [],
				"Handicap": [
					59
				],
				"Total": [
					239
				]
			},
			"priority": 0,
			"parent": null
		}
	},
	"40": {
		"0": {
			"headers": {
				"Result": [
					698,
					403
				],
				"Double": [
					656
				],
				"Handicap": [
					74
				],
				"Total": [
					349
				]
			},
			"priority": 0,
			"parent": null
		}
	},
	"41": {
		"0": {
			"headers": {
				"Result": [
					698,
					403
				],
				"Double": [
					656
				],
				"Handicap": [
					74
				],
				"Total": [
					349
				]
			},
			"priority": 0,
			"parent": null
		},
		"1": {
			"headers": {
				"Result": [
					673,
					366
				],
				"Double": [
					657
				],
				"Handicap": [
					21
				],
				"Total": [
					195
				]
			},
			"priority": 0,
			"parent": null
		},
		"2": {
			"headers": {
				"Result": [
					674,
					367
				],
				"Double": [
					658
				],
				"Handicap": [
					22
				],
				"Total": [
					196
				]
			},
			"priority": 0,
			"parent": null
		},
		"3": {
			"headers": {
				"Result": [
					685
				],
				"Double": [],
				"Handicap": [
					62
				],
				"Total": [
					248
				]
			},
			"priority": 0,
			"parent": null
		},
		"4": {
			"headers": {
				"Result": [
					684
				],
				"Double": [],
				"Handicap": [
					61
				],
				"Total": [
					246
				]
			},
			"priority": 0,
			"parent": null
		}
	},
	"42": {
		"0": {
			"headers": {
				"Result": [
					403,
					698
				],
				"Double": [],
				"Handicap": [
					74
				],
				"Total": [
					349
				]
			},
			"priority": 0,
			"parent": null
		},
		"1": {
			"headers": {
				"Result": [
					366,
					673
				],
				"Double": [],
				"Handicap": [],
				"Total": []
			},
			"priority": 1,
			"parent": null
		},
		"2": {
			"headers": {
				"Result": [
					367,
					674
				],
				"Double": [],
				"Handicap": [],
				"Total": []
			},
			"priority": 2,
			"parent": null
		},
		"3": {
			"headers": {
				"Result": [
					368,
					675
				],
				"Double": [],
				"Handicap": [],
				"Total": []
			},
			"priority": 3,
			"parent": null
		},
		"4": {
			"headers": {
				"Result": [
					369,
					676
				],
				"Double": [],
				"Handicap": [],
				"Total": []
			},
			"priority": 4,
			"parent": null
		},
		"5": {
			"headers": {
				"Result": [
					370,
					677
				],
				"Double": [],
				"Handicap": [],
				"Total": []
			},
			"priority": 5,
			"parent": null
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./js/shared/glossary/group-headers.json
// module id = 651
// module chunks = 2 4